var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHomeIcon1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 44,
    viewBox: "0 0 80 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_100_6952)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M51.6155 10.5445C37.3652 -3.51368 14.2536 -3.51368 0 10.5445L2.58011 13.0898C15.4077 0.435162 36.2078 0.438434 49.032 13.0898C51.8808 15.9001 56.5071 15.9001 59.3558 13.0898L56.7757 10.5445C55.353 11.948 53.0382 11.948 51.6122 10.5445H51.6155Z",
    fill: "#2D333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9678 30.9102C28.1191 28.0999 23.4928 28.0999 20.644 30.9102L23.2242 33.4555C24.6469 32.052 26.9617 32.052 28.3877 33.4555C42.638 47.5137 65.7529 47.5104 80.0032 33.4555L77.4231 30.9102C64.5988 43.5616 43.7954 43.5616 30.9711 30.9102H30.9678Z",
    fill: "#2D333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1314 25.8196C30.4339 20.199 21.1847 20.199 15.4839 25.8196L18.064 28.3649C22.3388 24.1478 29.2765 24.1511 33.548 28.3649C44.9495 39.6127 63.4381 39.6127 74.8397 28.3649L72.2596 25.8196C62.284 35.6606 46.1069 35.6606 36.1281 25.8196H36.1314Z",
    fill: "#2D333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.2916 20.7257C32.7421 12.2915 18.8731 12.2882 10.3203 20.7257L12.9037 23.2743C20.0339 16.2403 31.5814 16.2403 38.7115 23.2743C47.261 31.7085 61.1299 31.7151 69.6827 23.2743L67.0993 20.7257C59.9725 27.7564 48.4217 27.7564 41.2949 20.7257H41.2916Z",
    fill: "#2D333C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4519 15.6351C35.0503 4.38726 16.5617 4.38726 5.16016 15.6351L7.74027 18.1804C17.7158 8.33938 33.8962 8.33938 43.8718 18.1804C49.5692 23.801 58.8185 23.801 64.516 18.1804L61.9358 15.6351C57.6644 19.8489 50.7233 19.8489 46.4519 15.6351Z",
    fill: "#2D333C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_100_6952"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 44,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon1);
export default __webpack_public_path__ + "static/media/home_icon1.276c1dc8fecc8ef344e7eb2cc6901229.svg";
export { ForwardRef as ReactComponent };